import { createTheme } from "@mui/material/styles";
import { getComponentOverrides } from "./ComponentOverrides";
import { getTypography } from "./Typography";
import { getThemeBase } from "./ThemeBase";
import "typeface-work-sans";
import "typeface-roboto";
export const modernTheme = mode => {
  const theme = {
    ...getThemeBase(mode),
    ...getComponentOverrides(mode),
    ...getTypography()
  };
  return createTheme({
    ...theme
  });
};